import React from 'react';

import { Sparkles } from '@videoblocks/react-icons';

import { Button } from '../../../../../builder-io/storyblocks-design-system/components/atoms/Button/Button';
import ModalDialog from '../../../../Shared/ModalDialog';

interface CreditConfirmationModalProps {
  isOpen: boolean;
  creditCost: number;
  currentBalance: number;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const CreditConfirmationModal: React.FC<CreditConfirmationModalProps> = ({
  isOpen,
  creditCost,
  currentBalance,
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  const remainingCredits = currentBalance - creditCost;
  const hasRemainingCredits = remainingCredits >= 0;

  if (!hasRemainingCredits) {
    return null;
  }

  return (
    <ModalDialog
      isOpen={isOpen}
      onRequestClose={onCancel}
      headerText={`Generate this video for ${creditCost} credits?`}
      contentLabelClassName="font-normal mt-0 mb-10 text-gray-900"
      subHeaderText={
        <>
          <div className="mb-4">
            You'll have {remainingCredits} credit
            {remainingCredits !== 1 ? 's' : ''} remaining.
          </div>
          <div>This video will be generated at 720p.</div>
        </>
      }
      className="max-w-xl p-8"
      topOffsetClass="top-1/2 transform -translate-y-1/2"
      subHeaderTextClassName="text-base text-gray-900"
      contentLabelContainerClassName="space-y-0"
      closeButtonClassName="text-gray-700 font-light"
    >
      <div className="flex gap-3 justify-end">
        <Button variant="outlined-dark" onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={isLoading}>
          <div className="flex items-center gap-2">
            <Sparkles className="w-4 h-4 fill-black" />
            {isLoading ? 'Generating...' : 'Generate Video'}
          </div>
        </Button>
      </div>
    </ModalDialog>
  );
};

export default CreditConfirmationModal;
